import Component from "../abstracts/Component";
import { Matchmq } from "../utils/ResolutionHandler";

export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]',
      fitersInput: '.js-filters-checkbox',
      trackingPayload: '[data-tracking-payload]',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#sl__search__input',
    }
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el).closest(this.SELECTORS.dataTracking).find(this.SELECTORS.trackingPayload);
    }

    let products = [];
    elements.each(function () {
      products.push($(this).data());
    });
    return products
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: (products) => {
        if(products && products.length != 0) {
          try {
            this.log("tracking loadMore event with " + products.length + " more products");
            let productsData = this.getTrackingPayloadData(products, true);
            window.listViewMore(productsData);
          } catch(e) {
            this.log("listViewMore tracking function not available");
          }
        } else {
         this.warn("no products loaded");
         return;
        }
      },

      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];
          // TODO: add other templates..
          if (typeof product.template !== 'undefined') {
            if ("category-page" == product.template || "na:t-editorial-listing" == product.template || "na:t-editorial" == product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch(e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if (product.template == "na:c-recommendation-engine") {
              console.log("na:c-recommendation-engine");
              try {
                this.log("tracking listCarouselClick event for product: " + product.id);
                window.listCarouselClick('recommendation-engine', product);
              } catch(e) {
                this.warn("listCarouselClick tracking function not available");
              }
            } else if ("search-page" == product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch(e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch(e) {
                this.warn("listProdClick tracking function not available");
              }
            }
          }
          if (product.isAlgoliaEnabled) {
            this.actions.algolia(params, el);
          }
        }
      },
      listCarouselClick: (params, el) => {
        console.log(params);
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick(params.carouselName, product);
          } catch(e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      algolia: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          this.log('algolia ' + product);
          product.position = product.position + 1; //Algolia è 1-based e non 0-based
          this.log("Algolia " + product.position + ' ' + product.id);
          $.ajax({
            url: '/action/ajax/algolia-notification',
            type: 'post',
            cache: 'false',
            data: {
              positionId: product.position,
            },
            success: function (data) {
              console.log('algolia success')
            },
            error: function (errorObj, textStatus, errorThrown) {
              console.warn('algolia error')
            }
          });
        }
      },
      wishlistAdd: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to wishlist event with code: ' + productCode);
          utag.wishlist_add(productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from AddToCartComponent.js
      addToCart: (params) => {
        let productCode = params.productCode || params;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to cart event with code: ' + productCode);
          utag.cart_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeProduct: (params) => {
        let productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking removeProduct event with productCode: ' + params.productCode);
          utag.cart_remove_click(productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking removeQuantity event with productCode: ' + params.productCode);
          utag.cart_minus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking addQuantity event with productCode: ' + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      shortcutCategoryView: (params) => {
        try {
          this.log('Tracking shortcut category click: ' + params.shortcutLabel);
          var data = new Object();
          data['event_name'] = 'select_content';
          data['event_location'] = params.shortcutNumber// es. shortcut-micro_1, shortcut-macro_4 …
          data['event_detail'] = params.shortcutLabel// es. our selection, clothing, pantaloni, abiti, …
          data['content_type'] = params.shortcutType// es. shortcut-micro, shortcut-macro…
          utag.link(data)
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        this.log('[Tracking] NL-Subscription, type: ' + type + ' pos: ' + pos);
        ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
      },
      formisimo: (params) => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        let code = params.code;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking sizeSelection event with code: ' + code);
          utag.size_selection();
          let mainSizeRow = document.querySelector('.c-sizes-row');
          mainSizeRow.dataset.errorMessage = '';
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }
        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from FiltersComponent.js
      filterTracking: (params, productList) => {
        let facetCode = $(params).attr("data-facet-code");
        let code = $(params).attr("data-code");
        let productsData = this.getTrackingPayloadData(productList, true);
        if(facetCode && code && productsData) {
          this.log("Triggering filter " + facetCode + ": " + code);
          try {
            this.log('tracking link event: ' + code);
            utag.link({
              filter: facetCode + ":" + code,
              event_name: "filter_usage",
              productList: productsData
            });
          } catch(e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      sortTracking: (sortbyName, sortMethod, sortType, productList) => {
        let sortCode = "orderBy";
        let productsData = this.getTrackingPayloadData(productList, true);
        if(sortbyName && productList) {
          this.log("triggering filter " + sortCode + ": " + sortbyName);

          try {
            console.log("tracking link event: " + sortbyName);
            utag.link({
              filter: sortCode + ":" + sortbyName,
              sorting_method: sortMethod,
              sorting_type: sortType,
              event_name: "filter_usage",
              productList: productsData
            });
          } catch(e) {
            console.warn("utag tracking not available");
          }
        }
      },
      startChat: () => {
        utag.link({
          event_name: "chat_start"
        });
      },
      deleteChat: () => {
        utag.link({
          event_name: "chat_delete"
        });
      },
      addCartGiftCard: (params) => {
        utag.link({
          event_category: "gift card",
          event_action: "add to cart",
          event_label: "giftcart " + params,
          event_name: "giftcart_add_to_cart"
        });
      },
      newsletterSubscribe: (params) => {
        let position = params.trackingPosition;
        utag.link({
          event_name: "newsletter_subscribe",
          event_location: position
        });
      },
      whatsappStart: () => {
        utag.link({
          event_name: "whatsapp_start"
        });
      },
      login: (params) => {
        try {
          this.log('Tracking login event: loginType - ' + params.loginType);
          utag.link({
            event_name: "login",
            login_type: params.loginType
          });
        } catch(e) {
        this.warn("Utag tracking not available");
        }
      },
      register: (params) => {
        if(params && params[0]) {
          var data = params[0];
          this.log("Triggering register tracking");
          try {
            this.log('tracking register event: ' + JSON.stringify(data));
            utag.link({
              event_name: data.eventName,
              page_name: data.pageName,
              page_type: data.pageType,
              login_type: data.userType,
              store_country: data.storeCountry,
              event_method: data.eventMethod
            });
          } catch(e) {
            this.warn("Utag tracking not available");
          }
        }
      },
    }
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success";
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  trackCarousels() {
    let ctx = this;
    let carousels = document.querySelectorAll("[data-js-track-carousel]");
    if (carousels && carousels.length > 0) {
      carousels.forEach((carousel) => {
        //find the carousel component
        let carouselComponent = carousel.dataset.jsComponent;
        //check if it's actually a carousel
        if(carouselComponent && carousel.querySelector("[data-carousel='true']") && carousel.querySelector("[data-carousel='true']").classList.contains("slick-initialized")) {
          let carouselName = carousel.dataset.jsTrackCarousel;
          let uniqueProducts = carousel.querySelectorAll(".slick-slide:not(.slick-cloned)");
          let productList = [];
          Array.from(uniqueProducts).forEach( (uniqueProduct) => {
            productList.push(uniqueProduct.querySelector("[data-card]"));
          });
          try {
            let productsData = ctx.getTrackingPayloadData(productList, true);
            this.log("tracking '" + carouselName + "' carousel with " + productsData.length + " products");
            window.listCarouselImpression(carouselName, productsData);
          } catch(e) {
            this.warn("listCarouselImpression tracking not available");
          }
        }
      });
    }
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data['bs.tab'] != 'undefined') {
        delete data['bs.tab'];
      }
      this.log('[Tracking] tracking action caught: ' + action + ' - with params: ' + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('[Tracking] no tracking manager found for action ' + action);
    }
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        let data = $(event.currentTarget).data();
        let action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }
    }, 'body', this.SELECTORS.dataTracking);

    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $('body').on('track', (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener('load', (event) => {
      this.trackCarousels();
    });
  }
}
